<template>
  <div>
  <div class="couponUsePage">
      <XR-head titleText="我的优惠券" ref="headObj"></XR-head>
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
        <mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="" :title="'全部类型'+'('+couponCount.All+')'"/>
          <mu-tab value="0" :title="'平台优惠券'+'('+ couponCount.Platform +')'"/>
          <mu-tab value="1" :title="'店铺优惠券'+'('+ couponCount.Store +')'"/>
        </mu-tabs>
             <div  v-for="(couponRow,index) in couponList" :key="index" class="coupon_default_inner"> 
              <template> 
                <div class="coupon_default_name" @click="open(index)">
                  <div :class="(couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?'couponGrey':(couponRow.CouponType==0? 'couponRink':'couponYellow'))" class="couponLeft" >
                      <div class="coupon_discount" >
                          <p class="cost">￥</p>
                          <p class="money">{{couponRow.Money}}</p>
                      </div>
                  </div>
                  <div class="couponRight" :class="(couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?'couponGrey':(couponRow.CouponType==0? 'couponRink':'couponYellow'))">              
                    <div class="coupon_content" :style="{width:couponWidth+'px'}">
                      <p class="coupon_title">
                        <span class="coupon_type">{{couponRow.CouponTypeName}}</span> {{couponRow.Name}}
                      </p>
                      <p class="date">
                          使用时间：{{couponRow.StartTime}}-{{couponRow.EndTime}}
                      </p> 
                      <p class="limit" v-if="couponRow.FullMoney == 0">
                        使用门槛：无门槛
                      </p>
                      <p class="limit" v-if="couponRow.FullMoney > 0">
                        使用门槛：满{{couponRow.FullMoney}}元可用      
                      </p>      
                                    
                    </div>
                  </div>
                </div>
                <div class="btn" :style="{backgroundImage: 'url(' + (couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?bg3:(couponRow.CouponType==0? bg1:bg2)) + ')'}">
                    <mu-flat-button v-if="couponRow.Status=='未使用'" @click="btnClick(couponRow.Id)" label="去使用" class="demo-flat-button" primary/>
                    <span v-if="couponRow.Status=='已使用'">已使用</span>
                    <span v-if="couponRow.Status=='已过期'">已过期</span>
					<span v-if="couponRow.Status=='未开始'">未开始</span>
					<span v-if="couponRow.Status=='已锁定'">已锁定</span>
                </div>
              </template>
            </div>
        </v-scroll>
        
      <mu-dialog dialogClass="couponUse" :open="dialog" v-if="couponList.length>0">
        <img class="logo" src="/static/coupon/dialog-top.png" alt="">
        <div class="close">
             <mu-icon-button @click="close">
                <span>×</span>
              </mu-icon-button>
              <p></p>
        </div>
        <div class="dialogTop">
          <p class="title">{{couponList[openCount].Name}}</p>
          <P class="couponType"> {{couponList[openCount].Money}}元{{couponList[openCount].CouponTypeName}}</P>
          <div class="dialogPrice">
            <div class="dialog_bg">
              {{couponList[openCount].Money}} <span>元</span> 
            </div> 
          </div>
          <p class="utility_time">使用时间:{{couponList[openCount].StartTime}}-{{couponList[openCount].EndTime}}</p>
          <p class="limit" v-if="couponList[openCount].FullMoney>0">使用门槛:满{{couponList[openCount].FullMoney}}可用</p>
          <p class="limit" v-if="couponList[openCount].FullMoney==0">使用门槛:无门槛</p>
        </div>
        <div class="dialogBottom">
          <p class="produce"><span></span>使用说明</p>
          <div class="inner">
              <div v-html="couponList[openCount].Content"></div>
          </div>
        </div>
      </mu-dialog>
      
      <XR-toast ref="XRtoast"></XR-toast>
      <XR-PageTip ref="XRPageTip"></XR-PageTip>
	  <div class="btn-list" >
      <router-link to="/retail/coupon/CouponCenter">     
        <div class="btn" >去领券中心</div>
      </router-link>
      <router-link to="/retail/coupon/myCoupon">     
        <div class="btn btn2" >优惠券历史记录</div>
      </router-link>
      </div>
  </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        activeTab: this.$route.query.type,
        dialog: false,
        openCount:0,
        bg1:'/static/coupon/couponCenter1-4.png',
        bg2:'/static/coupon/couponCenter1-5.png',
        bg3:'/static/coupon/couponCenter1-6.png',
        couponWidth: document.documentElement.clientWidth-20-60-16-88,
        pageEnd : 0, // 结束页数
        num:15,
        scrollDone:function(){},
        couponInfo:{
          CouponType:this.$route.query.type,
          pageIndex:0
        },
		loaded:false,
        couponList:[],
        couponCount:{All:0,Platform:0,Store:0},
      }
    },
    mounted:function(){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
        return;
      }else{
        this.loginUrl = '/usercenter/person';
        this.WapMyCouponCount()
        this.WapMyCouponList(true)
      }
    },
    methods: {
      WapMyCouponList(isNewSearch){
          this.$refs.XRtoast.load()
          if(isNewSearch){        
            this.couponInfo.pageIndex=1
          }
          else{
            this.couponInfo.pageIndex++
          }
          var ths = this;

          ths.$post('/Shop/CouponServer/WapMyCouponList',
          JSON.stringify(this.couponInfo)
          ).then(function (res){
            ths.scrollDone()
            ths.$refs.XRtoast.hide()
            if(!res.IsSuccess){
              if(isNewSearch){
                ths.couponList = []
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
                ths.$refs.XRtoast.hide(res.Msg, true)
              }else{
                ths.$refs.XRtoast.failed(res.Msg, true)
              }          
            }else{
              if(isNewSearch){
                ths.couponList = res.Data.List
              }
              else{            
                for(var i = 0; i < res.Data.List.length;i++){            
                  ths.couponList.push(res.Data.List[i])
                }
              }
              ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
              if(ths.couponList.length <= 0){            
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
              }else{            
                ths.$refs.XRPageTip.initTip()
              }
              ths.loaded =false
              ths.$refs.XRtoast.hide()
            }
          });
        },
        WapMyCouponCount(){
          var ths = this
          ths.$post('/Shop/CouponServer/WapMyCouponCount')
            .then(function (res) { 
              if(res.IsSuccess){
                ths.couponCount = res.Data
              }
            })
        },
        onRefresh(done) {
          this.WapMyCouponList(true)
		  this.WapMyCouponCount()
          done() // call done      
        },
        btnClick(id){
          this.$router.push('/retail/coupon/couponUsingRemark?id='+id)
        },
        onInfinite(done) {
          this.scrollDone = done
          if(this.couponInfo.pageIndex+1 > this.pageEnd){
          
            //this.$refs.XRtoast.failed("已经到最后一页", true)\
            this.$refs.scroll.infiniteDone()
            return
          }
          this.WapMyCouponList(false);     
        },
        open (index) {
          this.dialog = true
          this.openCount = index
        },
        close () {
          this.dialog = false
        },
        handleTabChange (val) {
          this.activeTab = val
          this.couponInfo.CouponType = val
          this.WapMyCouponList(true)
        },
    }
  }
</script>
<style>
  .couponUsePage .mu-tabs{
    background: #fff;
  }
  .couponUsePage .mu-tabs .mu-tab-link .mu-tab-text{
    color: #999;
  }
  .couponUsePage .mu-tabs .mu-tab-active .mu-tab-text{
    color: #E95E88;
  }
  .couponUsePage{
    width: 100%;
    margin-bottom: 56px;
  }
  .couponUsePage .coupon_default_inner{
    width: 100%;
    display: flex;
    margin-top: 10px;
    padding: 0 10px;
    background-size: 100% 100%; 
    
  }
  .couponUsePage .coupon_default_inner .btn{
    background-size:100% 100%; 
    padding: 0 12px;
    display: flex;
    align-items: center;
  }
  .couponUsePage .coupon_default_inner .coupon_default_name{
    display: flex;
    background-image: url('../../../../static/coupon/couponCenter2-2.png');
    background-size: 100% 100%;
  }
  .couponUsePage .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
  .couponUsePage .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 4px;
  }
  .couponUsePage .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
  .couponUsePage .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
  .couponUsePage .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
  .couponUsePage .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
  .couponUsePage .coupon_default_inner .couponRight{
    padding: 10px 0;
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-right: 1px dotted #999;
    
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content p{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content .coupon_title{
    height: 25px;
    line-height: 23px;
    font-size: 16px;
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 3px;
  }
  .couponUsePage .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    color: #E95E88;
  }
  .couponUsePage .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content .date{
    font-size: 10px;
    color: #666;
    margin-top: 10px;
  }
  .couponUsePage .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
  }
  .couponUsePage .coupon_default_inner .btn span{
    width: 64px;
    text-align: center;
  }
  .couponUsePage .coupon_default_inner .btn .mu-flat-button{
    width: 64px;
    min-width: 64px;
    height: 26px;
    background: red;
  }
  .couponUsePage .coupon_default_inner .btn .mu-flat-button .mu-flat-button-label{
    color: #fff;
    padding: 0;
    font-size: 12px;
  }
  .couponUsePage .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
  .couponUsePage .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
  .mu-dialog.couponUse{
    position: relative;
    background: none;
  }
  .mu-dialog.couponUse .mu-dialog-body img.logo{
    width: 20%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -30px;
  }
  .mu-dialog.couponUse .mu-dialog-body .close{
    position: absolute;
    right: 10px;
    top: -50px;
  }
  .mu-dialog.couponUse .mu-dialog-body .close .mu-icon-button{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 0;
    background: #eee;
  }
  .mu-dialog.couponUse .mu-dialog-body .close .mu-icon-button span{
    font-size: 26px;
  }
  .mu-dialog.couponUse .mu-dialog-body .close p{
    width: 1px;
    height: 19px;
    border-left:1px dotted #ccc;
    margin-left: 15px;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogTop{
    padding:24px 16px 0 16px;
    background-image: url('../../../../static/coupon/dialog-bg2.png');
    background-size:100% 100%; 
  }
  .mu-dialog.couponUse .mu-dialog-body .title{
    text-align: center;
    color: #000;
    font-size: 18px;
    margin-top: 5px;
  }
  .mu-dialog.couponUse .mu-dialog-body .couponType{
    color: #000;
    font-size: 22px;
    text-align: center;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogPrice{
    margin-top: 5px;
    width: 100%;
    justify-content: center;
    border-radius: 5px;
    border: 2px solid #ddd;
    display: flex;
    width: 90%;
    margin-left: 5%;
    align-items: center;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogPrice .dialog_bg{
    width: 70%;
    height: 60px;
    background-image: url('/static/coupon/dilog.png');
    background-size:100% 100%; 
    margin: 8px 0;
    font-size: 28px;
    color: #fff;
    text-align: center;
    line-height: 60px;
  }
  .mu-dialog.couponUse .mu-dialog-body .utility_time{
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
  }
  .mu-dialog.couponUse .mu-dialog-body .limit{
    text-align: center;
    font-size: 14px;
    padding-bottom: 5px;
    border-bottom: 1px dashed #999;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogBottom{
    padding: 10px 0;
    background-image: url('../../../../static/coupon/dialog-bg.png');
    background-size:100% 100%; 
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogBottom .produce{
    padding: 0 16px;
    font-size: 14px;
    line-height: 20px;
  } 
  .mu-dialog.couponUse .mu-dialog-body .dialogBottom .produce span{
    width: 3px;
    height: 16px;
    background: red;
    margin-right: 10px;
    display: block;
    float: left;
    margin-top: 2px;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogBottom .inner{
    margin: 6px 0 0 0;
    text-align: left;
    height: 80px;
    overflow: auto;
    padding: 0 16px;
  }
  .mu-dialog.couponUse .mu-dialog-body .dialogBottom .inner ul{
    list-style: none;
    font-size: 12px;
    height: 100%;
  }
  .couponUsePage .btn-list{
    width: 100%;
    position: fixed;
    bottom: 0;
  }
  .couponUsePage .btn-list .btn{
    float: left;
    width: 50%;
    background: #FF9500;
    text-align: center;
    color:white;
    height: 56px;
    line-height: 56px;
  }
  .couponUsePage .btn-list .btn2{
    background: #FF0036;
  }
  .couponUsePage .xr-pageTip{
    top:104px;
    /**z-index: 666666;**/
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/coupon/couponUse.vue